import { render, staticRenderFns } from "./CallLogFiltering.vue?vue&type=template&id=10617573&scoped=true&"
import script from "./CallLogFiltering.vue?vue&type=script&lang=js&"
export * from "./CallLogFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10617573",
  null
  
)

export default component.exports